import { useEffect } from 'react';

import { FormControl, FormLabel, Select } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import SharedMessage from '../Message/SharedMessage';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedSelectInputProps } from './SelectInput.types';

const SharedSelectInput = ({
  section,
  label,
  options,
  onChange,
  message,
  required,
  value,
  formStateKey,
  formActions,
  disabled,
  subLabel,
  ...rest
}: SharedSelectInputProps) => {
  const dispatch = useAppDispatch();

  const isDisabled = useFormBinderDisabled(formStateKey, disabled);
  const htmlID = subLabel ? `${label} (${subLabel})` : label;

  useEffect(() => {
    if (!required) return;

    if (value === '' || value === undefined || value === null) {
      dispatch(formActions.addMissingMandatoryField({ name: htmlID, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(htmlID));
    }
  }, [required, value, htmlID, dispatch, formActions, section]);

  return (
    <FormControl isRequired={required}>
      {label && <FormLabel ml="0">{label}</FormLabel>}
      <Select
        variant="main"
        onChange={onChange}
        value={value}
        id={htmlID}
        borderColor={required && !value ? 'red' : 'inherit'}
        {...rest}
        disabled={isDisabled}
        title={isDisabled ? 'Editing is disabled' : ''}
        isRequired={required}
      >
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </Select>
      {message && (
        <SharedMessage
          {...message}
          section={section}
          formStateKey={formStateKey}
          formActions={formActions}
        />
      )}
    </FormControl>
  );
};

export default SharedSelectInput;
